import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/password-show.svg'
import _imports_1 from '@/assets/password-hide.svg'


const _hoisted_1 = { class: "jr-w-full jr-m-auto jr-max-w-login" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "jr-text-center jr-text-black-light jr-text-3.5xl jr-mb-14" }, "ログイン", -1)
const _hoisted_3 = { class: "jr-mb-14" }
const _hoisted_4 = { class: "jr-relative" }
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  alt: "eye open"
}
const _hoisted_6 = {
  key: 1,
  src: _imports_1,
  alt: "eye close"
}
const _hoisted_7 = { class: "jr-mt-5 jr-text-blue" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("パスワードをお忘れの方")
const _hoisted_9 = { class: "jr-text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UIInputField = _resolveComponent("UIInputField")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_UIButton = _resolveComponent("UIButton")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    class: "jr-w-full jr-h-screen jr-flex jr-flex-col jr-justify-center jr-items-center",
    autocomplete: "off",
    onSubmit: _ctx.submit
  }, {
    default: _withCtx(({ meta }) => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_UIInputField, {
          modelValue: _ctx.tenant,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tenant) = $event)),
          name: "tenant-input",
          placeholder: "テナント",
          type: "text",
          rules: "required:テナント",
          class: "jr-block jr-mx-auto jr-w-login jr-mb-7.5"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_UIInputField, {
          modelValue: _ctx.username,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.username) = $event)),
          name: "username-input",
          placeholder: "ユーザー名",
          type: "text",
          rules: "required:ユーザー名",
          class: "jr-block jr-mx-auto jr-w-login jr-mb-7.5"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_UIInputField, {
              modelValue: _ctx.password,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
              name: "password-input",
              placeholder: "パスワード",
              type: _ctx.showPassword ? 'text' : 'password',
              class: "jr-block jr-mx-auto jr-w-login",
              rules: "required:パスワード"
            }, null, 8, ["modelValue", "type"]),
            _createElementVNode("button", {
              type: "button",
              class: "jr-absolute jr-m-auto jr-right-4 jr-top-0 jr-bottom-0",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleShowPassword && _ctx.toggleShowPassword(...args)))
            }, [
              (!_ctx.showPassword)
                ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                : _createCommentVNode("", true),
              (_ctx.showPassword)
                ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_router_link, { to: "/forget_password" }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_UIButton, {
            label: "ログイン",
            class: "jr-py-4 jr-w-75 jr-border jr-border-blue jr-rounded-md jr-m-auto",
            disabled: !meta.valid,
            primitiveType: "submit",
            onClick: _ctx.handleSubmit
          }, null, 8, ["disabled", "onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onSubmit"]))
}